(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/init.js');
"use strict";

const {
  useDrawResults
} = svs.components.tipsen.hooks;
const {
  selectSportEvent,
  selectLeagueFromSportEvent
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  useSelector
} = ReactRedux;
const {
  getIsOngoing,
  getSportInfoMatchState,
  getIsFinished
} = svs.components.sportinfo.common.matchState;
const {
  getStatusTextBySportEventAndLeague
} = svs.components.sportinfo.sportConfig.helpers;
const {
  statusTexts
} = svs.components.sportinfo.sportConfig.sports.Default;
const {
  StatusCodes
} = svs.components.sport.sportEventCommon;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  useEffect,
  useState
} = React;
const {
  MatchResultTypes
} = svs.components.sport.tipsenShared.constants;
const {
  Result
} = svs.components.tipsen.couponStatic;
const getMatchStatusClass = sportEventStatus => {
  switch (sportEventStatus) {
    case StatusCodes.Postponed:
    case StatusCodes.Cancelled:
      return 'canceled';
    default:
      return getSportInfoMatchState(sportEventStatus);
  }
};
const statusTextsShortToFull = (matchStatus, isSmall) => {
  switch (matchStatus) {
    case statusTexts.Cancelled.short:
      return statusTexts.Cancelled.full;
    case statusTexts.Postponed.short:
      return isSmall ? statusTexts.Postponed.short : statusTexts.Postponed.full;
    default:
      return matchStatus;
  }
};
const Init = _ref => {
  var _getMatchStatusClass;
  let {
    drawEvent,
    drawNumber,
    productId,
    isCompressed,
    isResultPage
  } = _ref;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const shouldShowResultText = isResultPage || !(isCompressed && isExtraSmall);
  const {
    data
  } = useDrawResults({
    productId,
    drawNumber
  });
  const [currentDrawResult] = data;
  const eventNumber = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.eventNumber) || undefined;
  const currentMatchId = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.matchId) || undefined;
  const sportEvent = useSelector(state => selectSportEvent(state, currentMatchId));
  const league = useSelector(state => selectLeagueFromSportEvent(state, currentMatchId));
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const [matchStatusText, setMatchStatusText] = useState(() => statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league), isSmall));
  const isFinished = currentDrawResult ? currentDrawResult[eventNumber - 1].matchResultState >= MatchResultTypes.VERIFIED : false;
  const isOngoing = !isFinished && sportEvent ? getIsOngoing(sportEvent.sportEventStatus) || getIsFinished(sportEvent.sportEventStatus) : undefined;
  useEffect(() => {
    if (isFinished) {
      setMatchStatusText('FT');
      return;
    }
    if (!isOngoing) {
      setMatchStatusText(statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league)));
      return;
    }
    const matchClock = setInterval(() => {
      setMatchStatusText(statusTextsShortToFull(getStatusTextBySportEventAndLeague(sportEvent, league)));
    }, 1000);
    return () => {
      if (matchClock) {
        clearInterval(matchClock);
      }
    };
  }, [isOngoing, isFinished, sportEvent, league]);
  return React.createElement("div", {
    className: "pg_coupon_static__init"
  }, matchStatusText && shouldShowResultText && React.createElement("div", {
    className: "pg_coupon_static__init__text pg_coupon_static__init__text--".concat(isFinished ? 'finished' : (_getMatchStatusClass = getMatchStatusClass(sportEvent.sportEventStatus)) === null || _getMatchStatusClass === void 0 ? void 0 : _getMatchStatusClass.toLowerCase())
  }, matchStatusText), React.createElement(Result, {
    drawEvent: drawEvent,
    drawNumber: drawNumber,
    productId: productId
  }));
};
setGlobal('svs.components.tipsen.couponStatic.Init', Init);

 })(window);